if (!window.__vtScriptsInit) {
  window.__vtScriptsInit = true;
  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initCountUp();
    initGaleriaProducto();
    initVariantes();
    initHeroRotativo();
  });
}

function initHeroRotativo() {
  var wraps = document.querySelectorAll('[data-vt-hero-rotativo]');
  if (!wraps.length) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  wraps.forEach(function (wrap) {
    var imgs = wrap.querySelectorAll('.vt-hero-imagen-rotativa');
    if (imgs.length < 2 || reduced) return;
    var index = 0;
    setInterval(function () {
      imgs[index].classList.remove('vt-hero-imagen-activa');
      index = (index + 1) % imgs.length;
      imgs[index].classList.add('vt-hero-imagen-activa');
    }, 4000);
  });
}

function initReveal() {
  var els = document.querySelectorAll('.vt-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('vt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('vt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.01, rootMargin: '0px 0px -40px 0px' }
  );
  els.forEach(function (el) { observer.observe(el); });

  // Respaldo: si por lo que sea la animación no se dispara (conexión lenta,
  // bloque muy alto, etc.), nunca debe quedar contenido invisible para siempre.
  setTimeout(function () {
    document.querySelectorAll('.vt-reveal:not(.vt-visible)').forEach(function (el) {
      el.classList.add('vt-visible');
    });
  }, 2500);
}

function initCountUp() {
  var els = document.querySelectorAll('[data-vt-count]');
  if (!els.length) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        var el = entry.target;
        var target = parseFloat(el.getAttribute('data-vt-count')) || 0;
        var suffix = el.getAttribute('data-vt-suffix') || '';
        if (reduced) {
          el.textContent = target + suffix;
          return;
        }
        var duration = 1400;
        var start = null;
        function step(ts) {
          if (!start) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          el.textContent = Math.round(eased * target) + suffix;
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    },
    { threshold: 0.4 }
  );
  els.forEach(function (el) { observer.observe(el); });
}

function initGaleriaProducto() {
  var galeria = document.querySelector('[data-vt-galeria]');
  if (!galeria) return;
  var principal = galeria.querySelector('[data-vt-imagen-principal]');
  var minis = Array.prototype.slice.call(galeria.querySelectorAll('[data-vt-mini]'));
  if (!principal || !minis.length) return;

  function activarMini(mini) {
    var src = mini.getAttribute('data-full');
    if (!src) return;
    principal.src = src;
    minis.forEach(function (m) { m.classList.remove('vt-mini-activa'); });
    mini.classList.add('vt-mini-activa');
  }

  minis.forEach(function (mini) {
    mini.addEventListener('click', function () {
      activarMini(mini);
    });
  });

  var flechaPrev = galeria.querySelector('[data-vt-flecha="prev"]');
  var flechaNext = galeria.querySelector('[data-vt-flecha="next"]');
  function moverGaleria(direccion) {
    var actual = minis.findIndex(function (m) { return m.classList.contains('vt-mini-activa'); });
    if (actual === -1) actual = 0;
    var siguiente = (actual + direccion + minis.length) % minis.length;
    activarMini(minis[siguiente]);
  }
  if (flechaPrev) flechaPrev.addEventListener('click', function () { moverGaleria(-1); });
  if (flechaNext) flechaNext.addEventListener('click', function () { moverGaleria(1); });
}

function initVariantes() {
  var form = document.querySelector('[data-vt-form-producto]');
  if (!form) return;
  var dataEl = form.querySelector('[data-vt-variantes-json]');
  if (!dataEl) return;
  var variantes;
  try {
    variantes = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  var selects = form.querySelectorAll('[data-vt-opcion]');
  var idInput = form.querySelector('input[name="id"]');
  var precioEl = document.querySelector('[data-vt-precio-actual]');
  var precioCompareEl = document.querySelector('[data-vt-precio-comparado]');
  var boton = form.querySelector('[data-vt-boton-comprar]');

  function opcionesSeleccionadas() {
    var vals = [];
    selects.forEach(function (s) { vals.push(s.value); });
    return vals;
  }

  function actualizar() {
    var seleccion = opcionesSeleccionadas();
    var variante = variantes.find(function (v) {
      return v.options.every(function (opt, i) { return opt === seleccion[i]; });
    });
    if (!variante) return;
    idInput.value = variante.id;
    if (precioEl) precioEl.textContent = variante.price_formatted;
    if (precioCompareEl) {
      if (variante.compare_at_price_formatted) {
        precioCompareEl.textContent = variante.compare_at_price_formatted;
        precioCompareEl.style.display = '';
      } else {
        precioCompareEl.style.display = 'none';
      }
    }
    if (boton) {
      if (variante.available) {
        boton.disabled = false;
        boton.textContent = boton.getAttribute('data-texto-disponible') || boton.textContent;
      } else {
        boton.disabled = true;
        boton.textContent = boton.getAttribute('data-texto-agotado') || 'Agotado';
      }
    }
  }

  selects.forEach(function (s) { s.addEventListener('change', actualizar); });
}
